import AsyncStorage from '@react-native-async-storage/async-storage';
import { useNavigation } from '@react-navigation/native';
import { StatusBar } from 'expo-status-bar';
import React, { useContext, useEffect } from 'react';
import { ActivityIndicator, StyleSheet, Text, View } from 'react-native';
import ClientContext from '../../context/client';
import RegisterDriverContext from '../../context/registerDriver';
import RouteContext from '../../context/route';
import UserContext from '../../context/user';
import { themes } from '../../design/colors';

export default function LoadingAdmin() {
    const navigation = useNavigation();
    const { getRoute, getRouteDriver } = useContext(RouteContext);
    const { getDrivers } = useContext(RegisterDriverContext);
    const { getClients } = useContext(ClientContext);
    const { user, setUser } = useContext(UserContext);
    
    async function loading() {
        const role = await AsyncStorage.getItem('@lmatransportes:role');
        const roleName = await AsyncStorage.getItem('@lmatransportes:role_name');
        const accessToken = await AsyncStorage.getItem('@lmatransportes:accessToken');
        const name = await AsyncStorage.getItem('@lmatransportes:name');
        const email = await AsyncStorage.getItem('@lmatransportes:email');
        const user_id = await AsyncStorage.getItem('@lmatransportes:user_id');
        const dataUser = {...user, name, email, initials_name: name?.substr(0, 2).toUpperCase(), roleName, user_id, role };
        setUser(dataUser);
        if(accessToken) {
          if(role === '1'){
              await getRoute();
              await getDrivers();
              await getClients();
              navigation.reset({
                  index: 0,
                  routes: [{ name: "ReportAdmin" }],
              });
          }else if(role === '2'){
              await getRouteDriver();
              await getClients();
              navigation.reset({
                  index: 0,
                  routes: [{ name: "DashboardDriver" }],
              });
          }
        } else {
          navigation.reset({
            index: 0,
            routes: [{ name: "Login" }],
        });
        }
    }

    useEffect(() => {
        loading();
    },[]);
  return (
    <View style={styles.container}>
      <ActivityIndicator animating color={themes.colors.primary} size={'large'} />
      <StatusBar style="auto" />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#fff',
    alignItems: 'center',
    justifyContent: 'center',
  },
});
